import { Identifiable, OrganizationalUnit } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function moveOrganizationalUnit(httpClient: HttpClient) {
  return (
    organizationalUnit: Identifiable<OrganizationalUnit>,
    newParentUuid?: string,
    insertAfterUuid?: string,
  ) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/organizational-units/${organizationalUnit.uuid}/move`,
        method: HttpMethods.POST,
        data: {
          newParentUuid: newParentUuid ?? null,
          insertAfterUuid: insertAfterUuid ?? null,
        },
      })
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            cycle: "cycle",
            duplicateName: "Duplicated OrganizationalUnit Name",
          }),
        ),
      );
}

export { moveOrganizationalUnit };
